import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UIContext } from '../../context/UIContext'
import { useTranslation } from 'react-i18next'

const Step2View = (props) => {
    const { t } = useTranslation(['wizard'])
    const {
        onInputChange,
        suggestionCourses,
        onClickCourse,
        courseName,
        courseSelected,
        onSubmit,
        isNextStepEnabled,
        isSearching,
    } = props
    const [buttonLabel, setButtonLabel] = useState(t('wizard:next'))
    const { titleCaseFn } = useContext(UIContext)

    useEffect(() => {
        if (!!courseName && courseSelected === null) {
            setButtonLabel(t('wizard:create'))
        } else if (courseName && courseSelected) {
            setButtonLabel(t('wizard:join'))
        } else {
            setButtonLabel(t('wizard:next'))
        }
    }, [courseName, courseSelected, t])

    return (
        <div className="step-container responsive">
            <div className="onboarding-img step2"></div>
            <div className="onboarding-form">
                <div className="info">
                    <span className="step-label">{t('wizard:step')} 2/5</span>
                    <span className="step-title">{t('wizard:step2.title')}</span>
                    <p className="global-text">{t('wizard:step2.desc')}</p>
                </div>
                <form id="recomendations" onSubmit={onSubmit}>
                    <div className="recomendation-container">
                        <div>
                            <input
                                type="text"
                                value={titleCaseFn(courseName)}
                                placeholder={t('wizard:step2.input')}
                                onChange={(e) => onInputChange(e.target.value)}
                                className="form-input"
                            />
                            {isSearching && (
                                <span className="loading-span">
                                    <FontAwesomeIcon icon={['fa', 'spinner']} spin size="1x" />
                                </span>
                            )}
                        </div>
                        {suggestionCourses.length > 0 ? (
                            <div className="egg-card egg-list recomendations-list">
                                {suggestionCourses.map((course) => (
                                    <div
                                        className="list-item clickeable-item"
                                        key={course._id}
                                        onClick={onClickCourse(course)}
                                    >
                                        {titleCaseFn(course.name)}
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </form>
                <button
                    form="recomendations"
                    type="submit"
                    className="btn-next-wizard"
                    disabled={!isNextStepEnabled}
                >
                    {buttonLabel}
                </button>
            </div>
        </div>
    )
}

Step2View.propTypes = {
    prevStep: PropTypes.func.isRequired,
    nextStep: PropTypes.func.isRequired,
    maxEnrollStudents: PropTypes.number.isRequired,
    setMaxEnrollStudents: PropTypes.func.isRequired,
    suggestionCourses: PropTypes.array.isRequired,
    onClickCourse: PropTypes.func.isRequired,
    courseName: PropTypes.string.isRequired,
    setCourseName: PropTypes.func.isRequired,
    hqSelected: PropTypes.any.isRequired,
    success: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onInputChange: PropTypes.func,
    courseSelected: PropTypes.bool,
    isNextStepEnabled: PropTypes.bool,
    isSearching: PropTypes.bool,
}

export default Step2View
